<ng-container *ngTemplateOutlet="contentRef"></ng-container>
 <ng-template #contentRef>
    <ng-content></ng-content>
 </ng-template>
